import { useClientInfo } from 'global/cnr/contexts/useHelpers/useClientInfo';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import UiSaveButtons from '../../../components/buttons/UiSaveButtons';
import AppForm from '../../../components/forms/appForms/AppForm';
import { appFormTypes } from '../../../enums/appFormTypes';
import FullPageWrapper from '../../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import { Dropdown } from 'semantic-ui-react';
import { gEnums } from 'global/enums/globalEnums';
import { listHelpers } from 'global/lists/lists';

const _allowCommit = true

/** Component for Ammending Data 
  @description updates using (handleAmmendDataItems, handleDelete_dataItems)
 */
const UiStatus = (singleDataItem) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { clientInfo_state, paps_state } = states
  const { clientInfo_handlers } = handlers
  const { appArea } = paps_state
  const { events, clientEventsStatus, selectedEvent, updating } = clientInfo_state

  const { updateClientInfo, updateClientInfos } = useClientInfo()

  // local state  
  const [mainCaption] = useState(_.startCase(appArea) + ' Status')

  useEffect(() => {
    console.log('events', events)
    clientInfo_handlers.handleSet_clientEventsStatus(_.cloneDeep(events))
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [events]);

  // commits to the database
  const handleSaveAll = () => {
    const cb = () => clientInfo_handlers.handleStopUpdate()
    clientInfo_handlers.handleStartUpdate()
    updateClientInfos(events, clientEventsStatus, cb)
  }

  // commits to the database
  const handleCommit = () => {
    if (_allowCommit) {
      const cb = () => clientInfo_handlers.handleStopUpdate()
      clientInfo_handlers.handleStartUpdate()
      updateClientInfo(selectedEvent, cb)
    }
  }

  const handleClick_unselectEvent = () => clientInfo_handlers.handleShow_selectedClientEvent()
  const handleClick_selectEvent = (itemData) => clientInfo_handlers.handleShow_selectedClientEvent(itemData)
  const handleUpdateSelectedItem = (d) => clientInfo_handlers.handleShow_selectedClientEvent(d)

  const handleStatusChange = (e, data) => {
    e.stopPropagation()
    const _clientEventsStatus = { ...clientEventsStatus }
    const item = _.find(_clientEventsStatus, { _itemKey: data.itemkey })
    item.eventStatusType = data.value
    clientInfo_handlers.handleSet_clientEventsStatus(_clientEventsStatus)
  }

  const buttonsStatus = (itemData) => <Dropdown
    placeholder='Event Status'
    fluid
    search
    selection
    size={'mini'}
    itemkey={itemData?._itemKey}
    value={itemData?.eventStatusType}
    options={listHelpers.listList(gEnums.eventStatusTypes)}
    onChange={handleStatusChange}
  />

  const fnAltContent = (itemData) => {
    return buttonsStatus(itemData)
  }

  const list = () => {
    if (!clientEventsStatus) return []
    console.log('clientEventsStatus', clientEventsStatus)
    const ests = _.groupBy(clientEventsStatus, 'eventStatusType')
    const ims = _.map(ests, (aaa, key) => (
      <ItemMenuSquares
        menuItems={aaa}
        caption={_.startCase(key)}
        imsType={_imsTypes.inline}
        fn_altContent={fnAltContent}
        icon={'setting'}
        iconItem={'list'}
      />))
    return <div>
      {ims}
    </div>
  }

  const form = () => <AppForm
    appFormType={appFormTypes.eventStatus}
    data_parent={selectedEvent}
    handleSaveCaption={'Update Status'}
    handleUpdateParentData={handleUpdateSelectedItem}
  ></AppForm>

  const footer_list = () => {
    const btns = []
    btns.push({ oc: handleSaveAll, caption: 'Update All', icon: 'save', color: 'green' })
    return <UiSaveButtons others={btns} />
  }

  const footer_item = () => {
    const btns = []
    btns.push({ oc: handleClick_unselectEvent, caption: 'Back', icon: 'arrow left', color: 'black', fl: true })
    btns.push({ oc: handleCommit, caption: 'Update Status', icon: 'save', color: 'green' })
    return <UiSaveButtons others={btns} />
  }

  const wrapper_selected = () => <Wrapper
    content={form()}
    footer={footer_item()}
    wrapperType={wrapperTypes.padded}
    updating={updating}
    css={{ container: 'app-dark-mode' }}
  />

  const wrapper_list = () => <Wrapper
    content={list()}
    footer={footer_list()}
    wrapperType={wrapperTypes.padded}
    updating={updating}
    css={{ container: 'app-dark-mode' }}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={selectedEvent ? wrapper_selected() : wrapper_list()}
    topperCaption={mainCaption}
    topperCaption2={selectedEvent ? selectedEvent.name : null}
    handleCancel={selectedEvent ? handleClick_selectEvent : null}
    isBack={selectedEvent ? true : false}
  />

  return fullPageWrapper()
}

export default UiStatus